import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TitleCasePipe } from '@angular/common';
import { DialogTitleComponent } from '../../../../comps/dialog-title/dialog-title.component';
import { MaterialModule } from '../../../../material.module';

export interface IDeleteDataSourceOptions {
  sourceName: string;
  type: 'table' | 'query';
}

export interface IDeleteDataSourceConfirmation {
  shouldDelete?: boolean;
}

@Component({
    selector: 'app-delete-data-source',
    templateUrl: './delete-data-source.component.html',
    styleUrls: ['./delete-data-source.component.scss'],
    imports: [MaterialModule, DialogTitleComponent, TitleCasePipe]
})
export class DeleteDataSourceDialogComponent {

  public dialogRef = inject(MatDialogRef<DeleteDataSourceDialogComponent, IDeleteDataSourceConfirmation>);
  public data = inject<IDeleteDataSourceOptions>(MAT_DIALOG_DATA);

  constructor() {
    this.dialogRef?.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close();
      }
    });
  }

  confirmDelete() {
    this.dialogRef.close({ shouldDelete: true });
  }

}
